import { useCallback } from "react";
import { motion, useAnimate, useMotionValue } from "motion/react";
import { useLenis } from "lenis/react";
import { animationCurves } from "@utils/animationCurves";
import { IconArrowDown } from "@hawkins/assets";

type Props = {
  scrollTarget?: number | string | HTMLElement;
};

export const ScrollCueButton = ({ scrollTarget = window.innerHeight }: Props) => {
  const lenis = useLenis();
  const y = useMotionValue("0%");
  const [, animate] = useAnimate();

  const animateForward = useCallback(async () => {
    await animate(y, "100%", animationCurves.quart);
    y.set("-100%");
    animate(y, "0%", animationCurves.half);
  }, [animate, y]);

  const animateBackward = useCallback(async () => {
    await animate(y, "-100%", animationCurves.quart);
    y.set("100%");
    animate(y, "0%", animationCurves.half);
  }, [animate, y]);

  return (
    <button
      type="button"
      aria-label="Scroll down"
      onClick={() => lenis?.scrollTo(scrollTarget as Parameters<typeof lenis.scrollTo>[0])}
      onMouseEnter={animateForward}
      onMouseLeave={animateBackward}
      className="absolute bottom-3 right-3 size-[42px] rounded-[8px] bg-white/15 backdrop-blur-[25px] flex items-center justify-center z-10 text-white"
    >
      <span className="overflow-hidden inline-flex items-center">
        <motion.span style={{ y }} className="inline-flex">
          <IconArrowDown fill="white" aria-hidden />
        </motion.span>
      </span>
    </button>
  );
};
